import { Box, Popper, Typography, Tooltip } from "@mui/material";
import { format } from 'date-fns';
import { useState, useRef } from "react";
import { DefaultCard } from "../../assets/styled-components/card";
import moment from 'moment';
const SquareBoxRenderer = (props) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const tooltipRef = useRef(null);


  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const { value, values, ppmservice } = props;
  // console.log("asdfasdf", ppmservice);

  if (!value) return null;

  const { date, color } = value;



  // const filteredData = values?.data?.filter(
  //   (item) => 
  //     moment(item?.targetdate).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD') &&
  //     item?.femppmscheduledetails?.some(detail => detail?.femassetregisterId === item?.femassetregisterId) // Updated comparison
  // );


  // Filter data for only the specific cell's date
  const filteredData = values?.data?.filter(
    (item) =>
      moment(item?.targetdate).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD') &&
      (
        ppmservice === "FEMS"
          ? item?.femppmscheduledetails?.femassetregister?.assetno === props?.data?.assetno
          : item?.bemppmscheduledetails?.bemassetregister?.assetno === props?.data?.assetno
      )
  );

  

  // Group the filtered data by targetdate
  const groupedData = filteredData?.reduce((acc, item) => {
    const targetDate = moment(item?.targetdate).format('YYYY-MM-DD');
    if (!acc[targetDate]) {
      acc[targetDate] = [];
    }
    acc[targetDate].push(item);
    return acc;
  }, {});

  // console.log(props, "props")


  return (
    <>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <Box
          sx={{
            width: 35,
            height: 35,
            backgroundImage: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '15px',
          }}
        >
          {date && !isNaN(new Date(date)) ? format(new Date(date), 'dd') : ''}
        </Box>
      </div>

      <Popper open={showTooltip} anchorEl={anchorEl} placement="bottom">
        <DefaultCard>
          <Box
            sx={{
              padding: '8px', // Increase padding for better readability
              borderRadius: '4px',
              fontSize: '14px',
              // minWidth: '40px', // Set a minimum width for consistency
              // maxWidth: '200px', // Set a max width to avoid excessive resizing
              whiteSpace: 'nowrap', // Prevents text wrapping
              overflow: 'hidden', // Ensures clean display
              textOverflow: 'ellipsis', // Adds "..." if text is too long
            }}
          >
            {Object.values(groupedData).map((items, index) => {
              const item = items[0]; // Only take the first item in each group

              return (
                <Box key={index} sx={{ mb: 1 }}>
                  <Typography   color="primary" variant="outlined" fontSize={14}>
                  {ppmservice === "BEMS"
                      ? item?.bemscheduledworkorderheaders?.length > 0 &&
                        item?.bemscheduledworkorderheaders[0]?.workorderno
                        ? (item?.bemscheduledworkorderheaders[0]?.workorderno)
                          ? (item?.bemscheduledworkorderheaders[0]?.workorderno)
                          : ""
                        : ""
                      : item?.femscheduledworkorderheaders?.length > 0 &&
                        item?.femscheduledworkorderheaders[0]?.workorderno
                        ? (item?.femscheduledworkorderheaders[0]?.workorderno)
                          ? (item?.femscheduledworkorderheaders[0]?.workorderno)
                          : ""
                        : ""}
                  </Typography>
                  <Typography variant="body2" color="black">
                    <strong>Week </strong> {item?.week}
                  </Typography>
                  <Typography variant="body2" color="black">
                    <strong>Planned Date &nbsp;&nbsp;: </strong> {moment(item?.targetdate).format('DD MMM YYYY')}
                  </Typography>

                  <Typography variant="body2" color="black">
                    <strong>Actual Date &nbsp;&nbsp;&nbsp;&nbsp;: </strong>
                    {ppmservice === "BEMS"
                      ? item?.bemscheduledworkorderheaders?.length > 0 &&
                        item?.bemscheduledworkorderheaders[0]?.bemscheduledwocompletiondetails[0]?.enddate
                        ? moment(item?.bemscheduledworkorderheaders[0]?.bemscheduledwocompletiondetails[0]?.enddate).isValid()
                          ? moment(item?.bemscheduledworkorderheaders[0]?.bemscheduledwocompletiondetails[0]?.enddate).format('DD MMM YYYY')
                          : ""
                        : ""
                      : item?.femscheduledworkorderheaders?.length > 0 &&
                        item?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails[0]?.enddate
                        ? moment(item?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails[0]?.enddate).isValid()
                          ? moment(item?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails[0]?.enddate).format('DD MMM YYYY')
                          : ""
                        : ""}
                  </Typography>

                  <Typography variant="body2" color="black">
                    <strong>Next Actual Date &nbsp;&nbsp;&nbsp;&nbsp;: </strong>
                    {ppmservice === "BEMS"
                      ? item?.bemscheduledworkorderheaders?.length > 0 &&
                        item?.bemscheduledworkorderheaders[0]?.nextppmtargetdate
                        ? moment(item?.bemscheduledworkorderheaders[0]?.nextppmtargetdate).isValid()
                          ? moment(item?.bemscheduledworkorderheaders[0]?.nextppmtargetdate).format('DD MMM YYYY')
                          : ""
                        : ""
                      : item?.femscheduledworkorderheaders?.length > 0 &&
                        item?.femscheduledworkorderheaders[0]?.nextppmtargetdate
                        ? moment(item?.femscheduledworkorderheaders[0]?.nextppmtargetdate).isValid()
                          ? moment(item?.femscheduledworkorderheaders[0]?.nextppmtargetdate).format('DD MMM YYYY')
                          : ""
                        : ""}
                  </Typography>

                </Box>
              );
            })}
          </Box>
        </DefaultCard>
      </Popper>

    </>
  );
}
export default SquareBoxRenderer;

